import React from 'react';
import './contato.component.scss';
import SiteModel, { ComponentsModel } from '../../models/layout.model';
import MenuModel from '../../models/menu.model';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PersonIcon from '@mui/icons-material/Person';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import ApartmentIcon from '@mui/icons-material/Apartment';
import TextsmsIcon from '@mui/icons-material/Textsms';
import { Box, BoxProps, Button, styled, TextField, TextFieldProps } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import { SnackService } from '../../services/snack.service';
import { LoadingService } from '../../services/loading.service';
import { EnviaContatoService } from '../../services/api-pages.service';
import LabelsContatoModel from '../../models/labels-contato.model';

export type ContatoComponentProps = {
  itemSite: ComponentsModel;
  menu?: MenuModel;
}

function ContatoComponent(props: ContatoComponentProps) {

  const { value: nomeInputText, bind: bindNomeInputText, setValue: setNomeInputText } = useInput('');
  const { value: emailInputText, bind: bindEmailInputText, setValue: setEmailInputText } = useInput('');
  const { value: telefoneInputText, bind: bindTelefoneInputText, setValue: setTelefoneInputText } = useInput('');
  const { value: empresaInputText, bind: bindEmpresaInputText, setValue: setEmpresaInputText } = useInput('');
  const { value: mensagemInputText, bind: bindMensagemInputText, setValue: setMensagemInputText } = useInput('');

  var langContato: LabelsContatoModel = {
    pt: {
      nome: 'Nome',
      email: 'E-mail',
      tel: 'Telefone',
      empresa: 'Empresa',
      msg: 'Mensagem',
      enviar: 'Enviar',
      alertNome: 'O campo nome é obrigatório',
      alertEmail: 'O campo e-mail é obrigatório'
    },
    en: {
      nome: 'Name',
      email: 'Email',
      tel: 'Telephone',
      empresa: 'Company',
      msg: 'Message',
      enviar: 'Submit',
      alertNome: 'The name field is required',
      alertEmail: 'The email field is required.'
    }
  }
  
  var siteLang = localStorage.getItem("siteLang");

  if (!siteLang) {
    siteLang = 'pt';
  }

  var langAtual = langContato[siteLang];

  var dto: any;

  const EnviarFormulario = (e: any) => {
    e.stopPropagation();

    if (!nomeInputText) {
      SnackService.sendMSG(langAtual.alertNome);
      return;
    } else if (!emailInputText) {
      SnackService.sendMSG(langAtual.alertEmail);
      return;
    }

    dto = {
      author_id: localStorage.getItem("author_id"),
      nome_do_site: localStorage.getItem("nome_do_site"),
      logo: localStorage.getItem("logo"),
      email_para_envio_do_formulario: props.itemSite.contato?.email_para_envio_do_formulario,
      nome: nomeInputText,
      email: emailInputText,
      telefone: telefoneInputText,
      empresa: empresaInputText,
      mensagem: mensagemInputText
    };

    LoadingService.sendLoadingAtivo(true);

    EnviaContatoService(dto).then((res) => {
      LoadingService.sendLoadingAtivo(false);
      if (res.data?.error) {
        SnackService.sendMSG(res.data?.error);
      } else {
        SnackService.sendMSG('Formulário enviado.');

        setNomeInputText('');
        setEmailInputText('');
        setTelefoneInputText('');
        setEmpresaInputText('');
        setMensagemInputText('');
      }
    }).catch(err => {
      LoadingService.sendLoadingAtivo(false);
      SnackService.sendMSG('Erro com a conexão.');
      console.log(err);
    });


  }

  const css = `
    .MuiBox-root {
      border-color: ${props.itemSite.contato?.cor_do_campo ? props.itemSite.contato?.cor_do_campo + ' !important' : '#fff'};
    }

    .MuiBox-root .MuiInputBase-root input,
    .MuiBox-root .MuiInputBase-root {
      color: ${props.itemSite.contato?.cor_do_campo ? props.itemSite.contato?.cor_do_campo + ' !important' : '#fff'};
    }

    .MuiBox-root .MuiInputBase-root:hover:before, 
    .MuiBox-root .MuiInputBase-root:before {
      border-color: ${props.itemSite.contato?.cor_do_campo ? props.itemSite.contato?.cor_do_campo + ' !important' : '#000'};
    }

    .MuiBox-root .MuiInputLabel-root, 
    .MuiBox-root .MuiTextField-root .MuiInputLabel-root.Mui-focused {
      color: ${props.itemSite.contato?.cor_do_campo ? props.itemSite.contato?.cor_do_campo + ' !important' : '#fff'};
    }

    .MuiBox-root .MuiInputBase-root:hover:after, 
    .MuiBox-root .MuiInputBase-root:after {
      border-color: ${props.itemSite.contato?.cor_efeito_do_campo ? props.itemSite.contato?.cor_efeito_do_campo + ' !important' : '#fff'};
    }

    #${props.itemSite.contato?.id} .form h2 {
      color: ${props.itemSite.contato?.cor_do_titulo ? props.itemSite.contato?.cor_do_titulo + ' !important' : '#000'};
    }

    #${props.itemSite.contato?.id} .form h3,
    #${props.itemSite.contato?.id} .form h4 {
      color: ${props.itemSite.contato?.cor_do_texto ? props.itemSite.contato?.cor_do_texto + ' !important' : '#000'};
    }
  `;

  return (
    <section
      id={props.itemSite.contato?.id}
      className="contato"
      style={props.itemSite.contato?.bg ? { backgroundColor: props.itemSite.contato?.bg } : { backgroundColor: '#fff' }}
    >
      <style>{css}</style>
      <div className="container">
        <div className={"cols " + (props.itemSite.contato?.iframe ? 'col2' : 'col1')}>
          {
            props.itemSite.contato?.iframe &&
            <div className="maps" dangerouslySetInnerHTML={{ __html: props.itemSite.contato ? props.itemSite.contato.iframe.replaceAll('[iframe', '<iframe').replaceAll('iframe]', 'iframe>') : '' }}></div>
          }
          <div className="form">
            <h2>{props.itemSite.contato?.titulo}</h2>
            <h3 dangerouslySetInnerHTML={{ __html: props.itemSite.contato?.descricao ? props.itemSite.contato?.descricao : '' }}></h3>
            <h4>{props.itemSite.contato?.endereco}</h4>
            <div className="campos">
              <style>{css}</style>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <PersonIcon style={{
                  color: props.itemSite.contato?.cor_do_campo ? props.itemSite.contato?.cor_do_campo : '#fff',
                }} />
                <TextField {...bindNomeInputText} label={langAtual.nome} variant="standard" />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <MailOutlineIcon style={{
                  color: props.itemSite.contato?.cor_do_campo ? props.itemSite.contato?.cor_do_campo : '#fff',
                }} />
                <TextField {...bindEmailInputText} label={langAtual.email} variant="standard" />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <LocalPhoneIcon style={{
                  color: props.itemSite.contato?.cor_do_campo ? props.itemSite.contato?.cor_do_campo : '#fff',
                }} />
                <TextField {...bindTelefoneInputText} label={langAtual.tel} variant="standard" />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <ApartmentIcon style={{
                  color: props.itemSite.contato?.cor_do_campo ? props.itemSite.contato?.cor_do_campo : '#fff',
                }} />
                <TextField {...bindEmpresaInputText} label={langAtual.empresa} variant="standard" />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }} className="msg">
                <TextField {...bindMensagemInputText} multiline rows={4} maxRows={4} label={langAtual.msg} variant="filled" />
              </Box>
            </div>

            <Button
              style={{
                color: props.itemSite.contato?.cor_texto_do_botao ? props.itemSite.contato?.cor_texto_do_botao : '#fff',
                background: props.itemSite.contato?.cor_fundo_do_botao ? props.itemSite.contato?.cor_fundo_do_botao : '#fff'
              }}
              onClick={EnviarFormulario} className="bt">
              {langAtual.enviar}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContatoComponent;
